// @flow

import { gql } from "@apollo/client";
import { fragments as sidebarListItemFragments } from "../../../../components/Sidebar/SidebarListItem/graph";

export default gql`
  query orders(
    $first: Int!
    $after: String
    $filters: ActiveOrdersFilters
    $runQuery: Boolean!
  ) {
    ordersConnection: activeOrders(
      first: $first
      after: $after
      filters: $filters
    ) @include(if: $runQuery) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          ...SidebarListItem_order
        }
      }
    }
  }
  ${sidebarListItemFragments.order}
`;
